export const createUUID = () => {
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const array = new Uint8Array(1);
    const [n = 0] = crypto.getRandomValues(array);
    const r = n % 16;
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};